import { sequence } from '@angular/animations';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { DcService } from 'src/app/services/dc.service';
import { UserService } from 'src/app/services/user.service';
import { DcMaintainenceResponse } from '../../model/dc-maintainence-response';
import { SortableColumn } from '../../model/sort/sortable-column';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import { Fruit } from '../edit-store/edit-store.component';

@Component({
    selector: 'app-edit-dc',
    templateUrl: './edit-dc.component.html',
    styleUrls: ['./edit-dc.component.scss'],
    standalone: false
})
export class EditDcComponent implements OnInit {
  userAction:string=null;
  isDisabled: boolean = false;
  isHidden:boolean=false;
  user: UsersDataResponse;
  userData: UserData;
  dcForm: UntypedFormGroup;
  sortableColumn:SortableColumn;
  statusString:string;
  visible = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  dcEmailIds:any=[];
  dcLocation:string;

 

  
  constructor(private router: Router, private userservice: UserService,private fb: UntypedFormBuilder,
    private route:ActivatedRoute,private dcservice:DcService) {
    
    this.createForm();
     this.dcEmailIds=[];
     this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
    })
  }

  
  ngOnInit() {
   
          this.route.params.subscribe(
            (params) => 
            { 
      
              let dcNumber=params.dcNumber;
                         this.geDcDetailsBySequence(dcNumber);
             })
     
  
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;

    if (event.value) {
      if (this.validateEmail(event.value)) {  
    if ((value || '').trim()) {
      if(this.dcEmailIds ===null){
        this.dcEmailIds=[];
      }
      this.dcEmailIds.push({ value: event.value, invalid: false });
 
    }
  }else {
    this.dcEmailIds.push({ value: event.value, invalid: true });
    
  }
  this.updateEmailAddress();
  this.verifyAllEmails();
}
    // Reset the input value
    event.chipInput.clear();
  }

 

   dcData:DcMaintainenceResponse;

  geDcDetailsBySequence(dcNumber){
   this.dcservice.getDCByNumber(dcNumber).subscribe(data=>{
  this.dcData=data;
  this.dcData.dcEmails.forEach(item=>{
    this.dcEmailIds.push({ value: item, invalid: false })
   });
    
 
     this.dcLocation=this.dcData.dcLocation;
      this.dcForm.patchValue({
        dcLocation: this.dcData.dcLocation,
        dcLicense:this.dcData.dcLicenseNumber,
        dcName:this.dcData.dcName,
        dcAddress:this.dcData.dcAddress,
        dcCity:this.dcData.dcCity?this.dcData.dcCity.toUpperCase():"",
        dcProvince:this.dcData.dcProvince?this.dcData.dcProvince.toUpperCase():"",
        dcPostal_code:this.dcData.dcPostal_code,
        dcNumber:this.dcData.dcNumber,
        dcEmails:this.dcData.dcEmails,
       
        
      });  
   
   })
  }

  createForm() {
    this.dcForm = this.fb.group({
      dcLocation: [{value: '', disabled: true}, Validators.required],
      dcLicense: ['',Validators.required],
      dcName: ['',Validators.required],
      dcAddress: ['',Validators.required],
      dcCity: ['',Validators.required],
      dcProvince: ['',Validators.required],
      dcPostal_code:['',Validators.required],
      dcNumber:['',Validators.required],
      dcEmails:['',Validators.required]

      
    });

  }

  updateEmailAddress(){
      let emails=[];
    this.dcEmailIds.forEach(item=>{
      emails.push(item.value)

    })
    this.dcForm.patchValue({
      dcEmails:emails
 });
  }
  verifyAllEmails(){
    try{
   this.dcForm.controls.dcEmails.value.forEach(item=>{
    if(!this.validateEmail(item)){
    this.dcForm.controls['dcEmails'].setErrors({'incorrectEmail': true});
    throw new Error("Invalid Emails");
  }else{
    this.dcForm.controls['dcEmails'].setErrors(null);
    }
   }) 
  }catch(error){
  console.log(error)
  }
  }

  private validateArrayNotEmpty(c: UntypedFormControl) {
    if (c.value && c.value.length === 0) {
      return {
        validateArrayNotEmpty: { valid: false }
      };
    }
    return null;
  }
  remove(emailId:string): void {
    const index = this.dcEmailIds.map(e => e.value).indexOf(emailId);

    if (index >= 0) {
      this.dcEmailIds.splice(index, 1);
      this.updateEmailAddress();
    }
    this.verifyAllEmails();
  }

  getErrorMessage() {
    if (this.dcForm.controls.dcLocation.hasError('required')) {
      return 'You must enter a value';
    }

    
  }

  setUserStatus(event:MatSlideToggleChange){
    this.statusString=event.checked==true?'Active':'Inactive';
  }

  updateDcData(){
   
    this.updateEmailAddress();
    this.verifyAllEmails();
    this.dcservice.updateDc(this.dcForm.value,this.dcData.sequenceNumber).subscribe(data=>{
    console.log(data);
    this.backToSummary();
  })

  
  }

  backToSummary(){
    this.router.navigate(['/dcn-esign/administration/dc-maintainence']);
  }

  private validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

}
